// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Wz-z","smallCardRow":"Xz-z","largeCardRow":"Yz-z","productSearchRow":"Zz-z","curatedRow":"_z-z"};